import { useEffect } from "react";
import Lenis from "lenis";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import About from "@/components/site/About";
import Products from "@/components/site/Products";
import WhyChooseUs from "@/components/site/WhyChooseUs";
import Industries from "@/components/site/Industries";
import ExportProcess from "@/components/site/ExportProcess";
import Sustainability from "@/components/site/Sustainability";
import Certifications from "@/components/site/Certifications";
import FAQ from "@/components/site/FAQ";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import { QuoteDialogProvider } from "@/components/site/QuoteDialog";

export default function HomePage() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.15,
      anchors: { offset: -100 },
    });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <QuoteDialogProvider>
      <div className="min-h-screen bg-cream text-ink">
        <Header />
        <main>
          <Hero />
          <Marquee />
          <About />
          <Products />
          <WhyChooseUs />
          <Industries />
          <ExportProcess />
          <Sustainability />
          <Certifications />
          <FAQ />
          <Contact />
        </main>
        <Footer />
      </div>
    </QuoteDialogProvider>
  );
}
